import Image from 'next/legacy/image';
import { CurrentUser } from 'types';
import { NextLink } from 'components/NextLink';

import styles from './Stepper.module.scss';
import {HeadComponent} from "../HeadComponent";

export type StepperHeaderProps = {
  stepBack?: () => void;
  user?: CurrentUser;
  title: string;
};

export const StepperHeader = ({ title, stepBack, user }: StepperHeaderProps) => {

  return (
    <>
      <HeadComponent headTitle={title} />
    <div className={styles.headerContainer}>
      {!!stepBack && (
        <div className={styles.backButton} onClick={stepBack}>
          <p>Back</p>
        </div>
      )}
      <div className={styles.logoContainer}>
        <NextLink href="/">
          <Image src="/icons/logo.svg" width={90} height={24} alt="SENDY" />
        </NextLink>
      </div>
      {!user?.email && (
        <div className={styles.headerLeftSide}>
          <p>Already have an account?</p>
          <NextLink id="stepper-sign-in" href="/sign-in">
            Sign In
          </NextLink>
        </div>
      )}
    </div>
    </>
  );
};
